const fotos = [
  {
    src: '/images/TRABALHE-CONOSCO/EQUIPE/parada-geral-bracell-sp.webp',
    alt: 'Equipe Pilar em parada geral na Bracell SP',
  },
  {
    src: '/images/TRABALHE-CONOSCO/EQUIPE/parada-geral-klabin.webp',
    alt: 'Equipe Pilar em parada geral na Klabin',
  },
  {
    src: '/images/TRABALHE-CONOSCO/EQUIPE/parada-geral-eldorado.webp',
    alt: 'Equipe Pilar em parada geral na Eldorado',
  },
  {
    src: '/images/TRABALHE-CONOSCO/EQUIPE/parada-geral-suzano-mucuri.webp',
    alt: 'Equipe Pilar em parada geral na Suzano Mucuri',
  },
  {
    src: '/images/TRABALHE-CONOSCO/EQUIPE/parada-geral-canteiro.webp',
    alt: 'Equipe Pilar em canteiro de obras industrial',
  },
];

export default function EquipeSection() {
  return (
    <section className="relative bg-gp-graphite py-20 md:py-28 overflow-hidden">
      <div className="w-full px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-gp-yellow"></div>
            <span className="text-gp-yellow text-sm uppercase tracking-[0.3em] font-medium">Nosso Time</span>
            <div className="w-12 h-[2px] bg-gp-yellow"></div>
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white uppercase tracking-wider mb-4">
            Quem Faz a <span className="text-gp-yellow">Pilar</span>
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Conheça o time que transforma desafios industriais em resultados de excelência.
            Pessoas comprometidas, técnicas e apaixonadas pelo que fazem.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto">
          {fotos.map((foto, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg bg-gp-graphite-light"
            >
              <div className="w-full h-[280px] md:h-[320px] overflow-hidden">
                <img
                  src={foto.src}
                  alt={foto.alt}
                  className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-gp-graphite/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                <p className="text-white text-sm font-medium leading-relaxed">{foto.alt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}